export default __webpack_public_path__ + "static/1-5fc65dfc97bd7557140246edce2f55a4.png";